import React from "react";

export const SuiviConservation = ({ data }) => {
  const {
    lastFullReport,
    lastInspection,
    lastTransport,
    riskLevel,
    nextInspectionDue,
    nextFullReportDue,
    recommendation,
  } = data;

  return (
    <div className="bg-white border rounded-md p-6 shadow-sm">
      <h2 className="font-serif text-lg mb-4">Suivi de conservation de l'œuvre</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-dark">
        <div>
          <p className="font-medium">Dernier rapport complet :</p>
          <p>{lastFullReport || "Non renseigné"}</p>
        </div>
        <div>
          <p className="font-medium">Dernière inspection visuelle :</p>
          <p>{lastInspection || "Non renseignée"}</p>
        </div>
        <div>
          <p className="font-medium">Dernier transport :</p>
          <p>{lastTransport || "Non renseigné"}</p>
        </div>
        <div>
          <p className="font-medium">Niveau de risque estimé :</p>
          <p>{riskLevel || "Évaluation en attente"}</p>
        </div>
        <div>
          <p className="font-medium">Prochaine inspection conseillée :</p>
          <p>{nextInspectionDue || "À calculer"}</p>
        </div>
        <div>
          <p className="font-medium">Prochain rapport complet conseillé :</p>
          <p>{nextFullReportDue || "À planifier"}</p>
        </div>
      </div>

      <div className="mt-6">
        <h3 className="font-medium mb-2">Recommandation IA :</h3>
        <p className="text-sm text-gray-dark">{recommendation || "Aucune recommandation spécifique pour le moment."}</p>
      </div>
    </div>
  );
};
